import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  HeadingDisplay,
  DataTable,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { MainError } from '@/modules/trade/components/MainError';
import { MainLoading } from '@/modules/trade/components/MainLoading';
import { Money } from '@/modules/common/components/MoneyV2';
import { computed, onMounted, ref } from 'vue';
import {
  getProvisionedProfits,
  ProvisionedProfitResponse
} from '@/modules/wealth/services/portfolio';
import { columns } from './columns';

interface Props {
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProvisionedProfits',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}



const isLoading = ref(false);
const hasError = ref(false);
const profitData = ref<ProvisionedProfitResponse | null>(null);

const getProvisionedProfitData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    profitData.value = await getProvisionedProfits(props.portfolioId);
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const tableStatus = computed(() => {
  if (hasError.value) return 'error';
  if (isLoading.value) return 'loading';

  return 'default';
});

onMounted(getProvisionedProfitData);

return { __sfc: true,props, isLoading, hasError, profitData, getProvisionedProfitData, tableStatus, Heading, HeadingDisplay, DataTable, HelperViewStatus, MainError, MainLoading, Money, columns }
}

})